/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProtectedSupportToolsRouteImport } from './routes/_protected/support-tools'
import { Route as PublicLoginCallbackRouteImport } from './routes/_public/login.callback'
import { Route as ProtectedSupportToolsToolRouteImport } from './routes/_protected/support-tools/$tool'
import { Route as ProtectedpartialMatchesPartialMatchesRouteImport } from './routes/_protected/(partial-matches)/partial-matches'
import { Route as ProtectedorgOrgLayoutRouteImport } from './routes/_protected/(org)/_org-layout'
import { Route as ProtectedorgOrgLayoutOrgsOrgIdRouteImport } from './routes/_protected/(org)/_org-layout/orgs.$orgId'
import { Route as ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRouteImport } from './routes/_protected/(org)/_org-layout/orgs.$orgId/support-tools'
import { Route as ProtectedorgOrgLayoutOrgsOrgIdSupportToolsToolRouteImport } from './routes/_protected/(org)/_org-layout/orgs.$orgId/support-tools/$tool'

const ProtectedorgRouteImport = createFileRoute('/_protected/(org)')()
const ProtectedOrgsLazyRouteImport = createFileRoute('/_protected/orgs')()
const ProtectedpartialMatchesPartialMatchesByAppLazyRouteImport =
  createFileRoute('/_protected/(partial-matches)/partial-matches-by-app')()
const ProtectedpartialMatchesPartialMatchesByAppAppSlugLazyRouteImport =
  createFileRoute(
    '/_protected/(partial-matches)/partial-matches-by-app/$appSlug',
  )()
const ProtectedorgOrgLayoutOrgsOrgIdIndexLazyRouteImport = createFileRoute(
  '/_protected/(org)/_org-layout/orgs/$orgId/',
)()
const ProtectedorgOrgLayoutOrgsOrgIdUserTypesLazyRouteImport = createFileRoute(
  '/_protected/(org)/_org-layout/orgs/$orgId/user-types',
)()
const ProtectedorgOrgLayoutOrgsOrgIdTeamsLazyRouteImport = createFileRoute(
  '/_protected/(org)/_org-layout/orgs/$orgId/teams',
)()
const ProtectedorgOrgLayoutOrgsOrgIdTeamMappingLazyRouteImport =
  createFileRoute('/_protected/(org)/_org-layout/orgs/$orgId/team-mapping')()
const ProtectedorgOrgLayoutOrgsOrgIdPeopleLazyRouteImport = createFileRoute(
  '/_protected/(org)/_org-layout/orgs/$orgId/people',
)()
const ProtectedorgOrgLayoutOrgsOrgIdPartialMatchesLazyRouteImport =
  createFileRoute('/_protected/(org)/_org-layout/orgs/$orgId/partial-matches')()
const ProtectedorgOrgLayoutOrgsOrgIdDuplicatesLazyRouteImport = createFileRoute(
  '/_protected/(org)/_org-layout/orgs/$orgId/duplicates',
)()
const ProtectedorgOrgLayoutOrgsOrgIdAppDataLazyRouteImport = createFileRoute(
  '/_protected/(org)/_org-layout/orgs/$orgId/app-data',
)()
const ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesIndexLazyRouteImport =
  createFileRoute(
    '/_protected/(org)/_org-layout/orgs/$orgId/app-access-rules/',
  )()
const ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesCreateLazyRouteImport =
  createFileRoute(
    '/_protected/(org)/_org-layout/orgs/$orgId/app-access-rules/create',
  )()
const ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesRuleIdLazyRouteImport =
  createFileRoute(
    '/_protected/(org)/_org-layout/orgs/$orgId/app-access-rules/$ruleId',
  )()

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedorgRoute = ProtectedorgRouteImport.update({
  id: '/(org)',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedOrgsLazyRoute = ProtectedOrgsLazyRouteImport.update({
  id: '/orgs',
  path: '/orgs',
  getParentRoute: () => ProtectedRoute,
} as any).lazy(() =>
  import('./routes/_protected/orgs.lazy').then((d) => d.Route),
)
const ProtectedSupportToolsRoute = ProtectedSupportToolsRouteImport.update({
  id: '/support-tools',
  path: '/support-tools',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedpartialMatchesPartialMatchesByAppLazyRoute =
  ProtectedpartialMatchesPartialMatchesByAppLazyRouteImport.update({
    id: '/(partial-matches)/partial-matches-by-app',
    path: '/partial-matches-by-app',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/(partial-matches)/partial-matches-by-app.lazy').then(
      (d) => d.Route,
    ),
  )
const PublicLoginCallbackRoute = PublicLoginCallbackRouteImport.update({
  id: '/login/callback',
  path: '/login/callback',
  getParentRoute: () => PublicRoute,
} as any)
const ProtectedSupportToolsToolRoute =
  ProtectedSupportToolsToolRouteImport.update({
    id: '/$tool',
    path: '/$tool',
    getParentRoute: () => ProtectedSupportToolsRoute,
  } as any)
const ProtectedpartialMatchesPartialMatchesRoute =
  ProtectedpartialMatchesPartialMatchesRouteImport.update({
    id: '/(partial-matches)/partial-matches',
    path: '/partial-matches',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedorgOrgLayoutRoute = ProtectedorgOrgLayoutRouteImport.update({
  id: '/_org-layout',
  getParentRoute: () => ProtectedorgRoute,
} as any)
const ProtectedpartialMatchesPartialMatchesByAppAppSlugLazyRoute =
  ProtectedpartialMatchesPartialMatchesByAppAppSlugLazyRouteImport.update({
    id: '/$appSlug',
    path: '/$appSlug',
    getParentRoute: () => ProtectedpartialMatchesPartialMatchesByAppLazyRoute,
  } as any).lazy(() =>
    import('./routes/_protected/(partial-matches)/partial-matches-by-app/$appSlug.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedorgOrgLayoutOrgsOrgIdRoute =
  ProtectedorgOrgLayoutOrgsOrgIdRouteImport.update({
    id: '/orgs/$orgId',
    path: '/orgs/$orgId',
    getParentRoute: () => ProtectedorgOrgLayoutRoute,
  } as any)
const ProtectedorgOrgLayoutOrgsOrgIdIndexLazyRoute =
  ProtectedorgOrgLayoutOrgsOrgIdIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedorgOrgLayoutOrgsOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/(org)/_org-layout/orgs.$orgId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedorgOrgLayoutOrgsOrgIdUserTypesLazyRoute =
  ProtectedorgOrgLayoutOrgsOrgIdUserTypesLazyRouteImport.update({
    id: '/user-types',
    path: '/user-types',
    getParentRoute: () => ProtectedorgOrgLayoutOrgsOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/(org)/_org-layout/orgs.$orgId/user-types.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedorgOrgLayoutOrgsOrgIdTeamsLazyRoute =
  ProtectedorgOrgLayoutOrgsOrgIdTeamsLazyRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: () => ProtectedorgOrgLayoutOrgsOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/(org)/_org-layout/orgs.$orgId/teams.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedorgOrgLayoutOrgsOrgIdTeamMappingLazyRoute =
  ProtectedorgOrgLayoutOrgsOrgIdTeamMappingLazyRouteImport.update({
    id: '/team-mapping',
    path: '/team-mapping',
    getParentRoute: () => ProtectedorgOrgLayoutOrgsOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/(org)/_org-layout/orgs.$orgId/team-mapping.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedorgOrgLayoutOrgsOrgIdPeopleLazyRoute =
  ProtectedorgOrgLayoutOrgsOrgIdPeopleLazyRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => ProtectedorgOrgLayoutOrgsOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/(org)/_org-layout/orgs.$orgId/people.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedorgOrgLayoutOrgsOrgIdPartialMatchesLazyRoute =
  ProtectedorgOrgLayoutOrgsOrgIdPartialMatchesLazyRouteImport.update({
    id: '/partial-matches',
    path: '/partial-matches',
    getParentRoute: () => ProtectedorgOrgLayoutOrgsOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/(org)/_org-layout/orgs.$orgId/partial-matches.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedorgOrgLayoutOrgsOrgIdDuplicatesLazyRoute =
  ProtectedorgOrgLayoutOrgsOrgIdDuplicatesLazyRouteImport.update({
    id: '/duplicates',
    path: '/duplicates',
    getParentRoute: () => ProtectedorgOrgLayoutOrgsOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/(org)/_org-layout/orgs.$orgId/duplicates.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedorgOrgLayoutOrgsOrgIdAppDataLazyRoute =
  ProtectedorgOrgLayoutOrgsOrgIdAppDataLazyRouteImport.update({
    id: '/app-data',
    path: '/app-data',
    getParentRoute: () => ProtectedorgOrgLayoutOrgsOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/(org)/_org-layout/orgs.$orgId/app-data.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRoute =
  ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRouteImport.update({
    id: '/support-tools',
    path: '/support-tools',
    getParentRoute: () => ProtectedorgOrgLayoutOrgsOrgIdRoute,
  } as any)
const ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesIndexLazyRoute =
  ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesIndexLazyRouteImport.update({
    id: '/app-access-rules/',
    path: '/app-access-rules/',
    getParentRoute: () => ProtectedorgOrgLayoutOrgsOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/(org)/_org-layout/orgs.$orgId/app-access-rules/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesCreateLazyRoute =
  ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesCreateLazyRouteImport.update({
    id: '/app-access-rules/create',
    path: '/app-access-rules/create',
    getParentRoute: () => ProtectedorgOrgLayoutOrgsOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/(org)/_org-layout/orgs.$orgId/app-access-rules/create.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesRuleIdLazyRoute =
  ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesRuleIdLazyRouteImport.update({
    id: '/app-access-rules/$ruleId',
    path: '/app-access-rules/$ruleId',
    getParentRoute: () => ProtectedorgOrgLayoutOrgsOrgIdRoute,
  } as any).lazy(() =>
    import('./routes/_protected/(org)/_org-layout/orgs.$orgId/app-access-rules/$ruleId.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedorgOrgLayoutOrgsOrgIdSupportToolsToolRoute =
  ProtectedorgOrgLayoutOrgsOrgIdSupportToolsToolRouteImport.update({
    id: '/$tool',
    path: '/$tool',
    getParentRoute: () => ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ProtectedorgOrgLayoutRouteWithChildren
  '/support-tools': typeof ProtectedSupportToolsRouteWithChildren
  '/orgs': typeof ProtectedOrgsLazyRoute
  '/partial-matches': typeof ProtectedpartialMatchesPartialMatchesRoute
  '/support-tools/$tool': typeof ProtectedSupportToolsToolRoute
  '/login/callback': typeof PublicLoginCallbackRoute
  '/partial-matches-by-app': typeof ProtectedpartialMatchesPartialMatchesByAppLazyRouteWithChildren
  '/partial-matches-by-app/$appSlug': typeof ProtectedpartialMatchesPartialMatchesByAppAppSlugLazyRoute
  '/orgs/$orgId': typeof ProtectedorgOrgLayoutOrgsOrgIdRouteWithChildren
  '/orgs/$orgId/support-tools': typeof ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRouteWithChildren
  '/orgs/$orgId/app-data': typeof ProtectedorgOrgLayoutOrgsOrgIdAppDataLazyRoute
  '/orgs/$orgId/duplicates': typeof ProtectedorgOrgLayoutOrgsOrgIdDuplicatesLazyRoute
  '/orgs/$orgId/partial-matches': typeof ProtectedorgOrgLayoutOrgsOrgIdPartialMatchesLazyRoute
  '/orgs/$orgId/people': typeof ProtectedorgOrgLayoutOrgsOrgIdPeopleLazyRoute
  '/orgs/$orgId/team-mapping': typeof ProtectedorgOrgLayoutOrgsOrgIdTeamMappingLazyRoute
  '/orgs/$orgId/teams': typeof ProtectedorgOrgLayoutOrgsOrgIdTeamsLazyRoute
  '/orgs/$orgId/user-types': typeof ProtectedorgOrgLayoutOrgsOrgIdUserTypesLazyRoute
  '/orgs/$orgId/': typeof ProtectedorgOrgLayoutOrgsOrgIdIndexLazyRoute
  '/orgs/$orgId/support-tools/$tool': typeof ProtectedorgOrgLayoutOrgsOrgIdSupportToolsToolRoute
  '/orgs/$orgId/app-access-rules/$ruleId': typeof ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesRuleIdLazyRoute
  '/orgs/$orgId/app-access-rules/create': typeof ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesCreateLazyRoute
  '/orgs/$orgId/app-access-rules': typeof ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof ProtectedorgOrgLayoutRouteWithChildren
  '/support-tools': typeof ProtectedSupportToolsRouteWithChildren
  '/orgs': typeof ProtectedOrgsLazyRoute
  '/partial-matches': typeof ProtectedpartialMatchesPartialMatchesRoute
  '/support-tools/$tool': typeof ProtectedSupportToolsToolRoute
  '/login/callback': typeof PublicLoginCallbackRoute
  '/partial-matches-by-app': typeof ProtectedpartialMatchesPartialMatchesByAppLazyRouteWithChildren
  '/partial-matches-by-app/$appSlug': typeof ProtectedpartialMatchesPartialMatchesByAppAppSlugLazyRoute
  '/orgs/$orgId/support-tools': typeof ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRouteWithChildren
  '/orgs/$orgId/app-data': typeof ProtectedorgOrgLayoutOrgsOrgIdAppDataLazyRoute
  '/orgs/$orgId/duplicates': typeof ProtectedorgOrgLayoutOrgsOrgIdDuplicatesLazyRoute
  '/orgs/$orgId/partial-matches': typeof ProtectedorgOrgLayoutOrgsOrgIdPartialMatchesLazyRoute
  '/orgs/$orgId/people': typeof ProtectedorgOrgLayoutOrgsOrgIdPeopleLazyRoute
  '/orgs/$orgId/team-mapping': typeof ProtectedorgOrgLayoutOrgsOrgIdTeamMappingLazyRoute
  '/orgs/$orgId/teams': typeof ProtectedorgOrgLayoutOrgsOrgIdTeamsLazyRoute
  '/orgs/$orgId/user-types': typeof ProtectedorgOrgLayoutOrgsOrgIdUserTypesLazyRoute
  '/orgs/$orgId': typeof ProtectedorgOrgLayoutOrgsOrgIdIndexLazyRoute
  '/orgs/$orgId/support-tools/$tool': typeof ProtectedorgOrgLayoutOrgsOrgIdSupportToolsToolRoute
  '/orgs/$orgId/app-access-rules/$ruleId': typeof ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesRuleIdLazyRoute
  '/orgs/$orgId/app-access-rules/create': typeof ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesCreateLazyRoute
  '/orgs/$orgId/app-access-rules': typeof ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_protected/support-tools': typeof ProtectedSupportToolsRouteWithChildren
  '/_protected/orgs': typeof ProtectedOrgsLazyRoute
  '/_protected/(org)': typeof ProtectedorgRouteWithChildren
  '/_protected/(org)/_org-layout': typeof ProtectedorgOrgLayoutRouteWithChildren
  '/_protected/(partial-matches)/partial-matches': typeof ProtectedpartialMatchesPartialMatchesRoute
  '/_protected/support-tools/$tool': typeof ProtectedSupportToolsToolRoute
  '/_public/login/callback': typeof PublicLoginCallbackRoute
  '/_protected/(partial-matches)/partial-matches-by-app': typeof ProtectedpartialMatchesPartialMatchesByAppLazyRouteWithChildren
  '/_protected/(partial-matches)/partial-matches-by-app/$appSlug': typeof ProtectedpartialMatchesPartialMatchesByAppAppSlugLazyRoute
  '/_protected/(org)/_org-layout/orgs/$orgId': typeof ProtectedorgOrgLayoutOrgsOrgIdRouteWithChildren
  '/_protected/(org)/_org-layout/orgs/$orgId/support-tools': typeof ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRouteWithChildren
  '/_protected/(org)/_org-layout/orgs/$orgId/app-data': typeof ProtectedorgOrgLayoutOrgsOrgIdAppDataLazyRoute
  '/_protected/(org)/_org-layout/orgs/$orgId/duplicates': typeof ProtectedorgOrgLayoutOrgsOrgIdDuplicatesLazyRoute
  '/_protected/(org)/_org-layout/orgs/$orgId/partial-matches': typeof ProtectedorgOrgLayoutOrgsOrgIdPartialMatchesLazyRoute
  '/_protected/(org)/_org-layout/orgs/$orgId/people': typeof ProtectedorgOrgLayoutOrgsOrgIdPeopleLazyRoute
  '/_protected/(org)/_org-layout/orgs/$orgId/team-mapping': typeof ProtectedorgOrgLayoutOrgsOrgIdTeamMappingLazyRoute
  '/_protected/(org)/_org-layout/orgs/$orgId/teams': typeof ProtectedorgOrgLayoutOrgsOrgIdTeamsLazyRoute
  '/_protected/(org)/_org-layout/orgs/$orgId/user-types': typeof ProtectedorgOrgLayoutOrgsOrgIdUserTypesLazyRoute
  '/_protected/(org)/_org-layout/orgs/$orgId/': typeof ProtectedorgOrgLayoutOrgsOrgIdIndexLazyRoute
  '/_protected/(org)/_org-layout/orgs/$orgId/support-tools/$tool': typeof ProtectedorgOrgLayoutOrgsOrgIdSupportToolsToolRoute
  '/_protected/(org)/_org-layout/orgs/$orgId/app-access-rules/$ruleId': typeof ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesRuleIdLazyRoute
  '/_protected/(org)/_org-layout/orgs/$orgId/app-access-rules/create': typeof ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesCreateLazyRoute
  '/_protected/(org)/_org-layout/orgs/$orgId/app-access-rules/': typeof ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/support-tools'
    | '/orgs'
    | '/partial-matches'
    | '/support-tools/$tool'
    | '/login/callback'
    | '/partial-matches-by-app'
    | '/partial-matches-by-app/$appSlug'
    | '/orgs/$orgId'
    | '/orgs/$orgId/support-tools'
    | '/orgs/$orgId/app-data'
    | '/orgs/$orgId/duplicates'
    | '/orgs/$orgId/partial-matches'
    | '/orgs/$orgId/people'
    | '/orgs/$orgId/team-mapping'
    | '/orgs/$orgId/teams'
    | '/orgs/$orgId/user-types'
    | '/orgs/$orgId/'
    | '/orgs/$orgId/support-tools/$tool'
    | '/orgs/$orgId/app-access-rules/$ruleId'
    | '/orgs/$orgId/app-access-rules/create'
    | '/orgs/$orgId/app-access-rules'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/support-tools'
    | '/orgs'
    | '/partial-matches'
    | '/support-tools/$tool'
    | '/login/callback'
    | '/partial-matches-by-app'
    | '/partial-matches-by-app/$appSlug'
    | '/orgs/$orgId/support-tools'
    | '/orgs/$orgId/app-data'
    | '/orgs/$orgId/duplicates'
    | '/orgs/$orgId/partial-matches'
    | '/orgs/$orgId/people'
    | '/orgs/$orgId/team-mapping'
    | '/orgs/$orgId/teams'
    | '/orgs/$orgId/user-types'
    | '/orgs/$orgId'
    | '/orgs/$orgId/support-tools/$tool'
    | '/orgs/$orgId/app-access-rules/$ruleId'
    | '/orgs/$orgId/app-access-rules/create'
    | '/orgs/$orgId/app-access-rules'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/_public'
    | '/_protected/support-tools'
    | '/_protected/orgs'
    | '/_protected/(org)'
    | '/_protected/(org)/_org-layout'
    | '/_protected/(partial-matches)/partial-matches'
    | '/_protected/support-tools/$tool'
    | '/_public/login/callback'
    | '/_protected/(partial-matches)/partial-matches-by-app'
    | '/_protected/(partial-matches)/partial-matches-by-app/$appSlug'
    | '/_protected/(org)/_org-layout/orgs/$orgId'
    | '/_protected/(org)/_org-layout/orgs/$orgId/support-tools'
    | '/_protected/(org)/_org-layout/orgs/$orgId/app-data'
    | '/_protected/(org)/_org-layout/orgs/$orgId/duplicates'
    | '/_protected/(org)/_org-layout/orgs/$orgId/partial-matches'
    | '/_protected/(org)/_org-layout/orgs/$orgId/people'
    | '/_protected/(org)/_org-layout/orgs/$orgId/team-mapping'
    | '/_protected/(org)/_org-layout/orgs/$orgId/teams'
    | '/_protected/(org)/_org-layout/orgs/$orgId/user-types'
    | '/_protected/(org)/_org-layout/orgs/$orgId/'
    | '/_protected/(org)/_org-layout/orgs/$orgId/support-tools/$tool'
    | '/_protected/(org)/_org-layout/orgs/$orgId/app-access-rules/$ruleId'
    | '/_protected/(org)/_org-layout/orgs/$orgId/app-access-rules/create'
    | '/_protected/(org)/_org-layout/orgs/$orgId/app-access-rules/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/(org)': {
      id: '/_protected/(org)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedorgRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/orgs': {
      id: '/_protected/orgs'
      path: '/orgs'
      fullPath: '/orgs'
      preLoaderRoute: typeof ProtectedOrgsLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/support-tools': {
      id: '/_protected/support-tools'
      path: '/support-tools'
      fullPath: '/support-tools'
      preLoaderRoute: typeof ProtectedSupportToolsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/(partial-matches)/partial-matches-by-app': {
      id: '/_protected/(partial-matches)/partial-matches-by-app'
      path: '/partial-matches-by-app'
      fullPath: '/partial-matches-by-app'
      preLoaderRoute: typeof ProtectedpartialMatchesPartialMatchesByAppLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_public/login/callback': {
      id: '/_public/login/callback'
      path: '/login/callback'
      fullPath: '/login/callback'
      preLoaderRoute: typeof PublicLoginCallbackRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_protected/support-tools/$tool': {
      id: '/_protected/support-tools/$tool'
      path: '/$tool'
      fullPath: '/support-tools/$tool'
      preLoaderRoute: typeof ProtectedSupportToolsToolRouteImport
      parentRoute: typeof ProtectedSupportToolsRoute
    }
    '/_protected/(partial-matches)/partial-matches': {
      id: '/_protected/(partial-matches)/partial-matches'
      path: '/partial-matches'
      fullPath: '/partial-matches'
      preLoaderRoute: typeof ProtectedpartialMatchesPartialMatchesRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/(org)/_org-layout': {
      id: '/_protected/(org)/_org-layout'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ProtectedorgOrgLayoutRouteImport
      parentRoute: typeof ProtectedorgRoute
    }
    '/_protected/(partial-matches)/partial-matches-by-app/$appSlug': {
      id: '/_protected/(partial-matches)/partial-matches-by-app/$appSlug'
      path: '/$appSlug'
      fullPath: '/partial-matches-by-app/$appSlug'
      preLoaderRoute: typeof ProtectedpartialMatchesPartialMatchesByAppAppSlugLazyRouteImport
      parentRoute: typeof ProtectedpartialMatchesPartialMatchesByAppLazyRoute
    }
    '/_protected/(org)/_org-layout/orgs/$orgId': {
      id: '/_protected/(org)/_org-layout/orgs/$orgId'
      path: '/orgs/$orgId'
      fullPath: '/orgs/$orgId'
      preLoaderRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdRouteImport
      parentRoute: typeof ProtectedorgOrgLayoutRoute
    }
    '/_protected/(org)/_org-layout/orgs/$orgId/': {
      id: '/_protected/(org)/_org-layout/orgs/$orgId/'
      path: '/'
      fullPath: '/orgs/$orgId/'
      preLoaderRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdIndexLazyRouteImport
      parentRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdRoute
    }
    '/_protected/(org)/_org-layout/orgs/$orgId/user-types': {
      id: '/_protected/(org)/_org-layout/orgs/$orgId/user-types'
      path: '/user-types'
      fullPath: '/orgs/$orgId/user-types'
      preLoaderRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdUserTypesLazyRouteImport
      parentRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdRoute
    }
    '/_protected/(org)/_org-layout/orgs/$orgId/teams': {
      id: '/_protected/(org)/_org-layout/orgs/$orgId/teams'
      path: '/teams'
      fullPath: '/orgs/$orgId/teams'
      preLoaderRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdTeamsLazyRouteImport
      parentRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdRoute
    }
    '/_protected/(org)/_org-layout/orgs/$orgId/team-mapping': {
      id: '/_protected/(org)/_org-layout/orgs/$orgId/team-mapping'
      path: '/team-mapping'
      fullPath: '/orgs/$orgId/team-mapping'
      preLoaderRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdTeamMappingLazyRouteImport
      parentRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdRoute
    }
    '/_protected/(org)/_org-layout/orgs/$orgId/people': {
      id: '/_protected/(org)/_org-layout/orgs/$orgId/people'
      path: '/people'
      fullPath: '/orgs/$orgId/people'
      preLoaderRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdPeopleLazyRouteImport
      parentRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdRoute
    }
    '/_protected/(org)/_org-layout/orgs/$orgId/partial-matches': {
      id: '/_protected/(org)/_org-layout/orgs/$orgId/partial-matches'
      path: '/partial-matches'
      fullPath: '/orgs/$orgId/partial-matches'
      preLoaderRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdPartialMatchesLazyRouteImport
      parentRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdRoute
    }
    '/_protected/(org)/_org-layout/orgs/$orgId/duplicates': {
      id: '/_protected/(org)/_org-layout/orgs/$orgId/duplicates'
      path: '/duplicates'
      fullPath: '/orgs/$orgId/duplicates'
      preLoaderRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdDuplicatesLazyRouteImport
      parentRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdRoute
    }
    '/_protected/(org)/_org-layout/orgs/$orgId/app-data': {
      id: '/_protected/(org)/_org-layout/orgs/$orgId/app-data'
      path: '/app-data'
      fullPath: '/orgs/$orgId/app-data'
      preLoaderRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdAppDataLazyRouteImport
      parentRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdRoute
    }
    '/_protected/(org)/_org-layout/orgs/$orgId/support-tools': {
      id: '/_protected/(org)/_org-layout/orgs/$orgId/support-tools'
      path: '/support-tools'
      fullPath: '/orgs/$orgId/support-tools'
      preLoaderRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRouteImport
      parentRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdRoute
    }
    '/_protected/(org)/_org-layout/orgs/$orgId/app-access-rules/': {
      id: '/_protected/(org)/_org-layout/orgs/$orgId/app-access-rules/'
      path: '/app-access-rules'
      fullPath: '/orgs/$orgId/app-access-rules'
      preLoaderRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesIndexLazyRouteImport
      parentRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdRoute
    }
    '/_protected/(org)/_org-layout/orgs/$orgId/app-access-rules/create': {
      id: '/_protected/(org)/_org-layout/orgs/$orgId/app-access-rules/create'
      path: '/app-access-rules/create'
      fullPath: '/orgs/$orgId/app-access-rules/create'
      preLoaderRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesCreateLazyRouteImport
      parentRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdRoute
    }
    '/_protected/(org)/_org-layout/orgs/$orgId/app-access-rules/$ruleId': {
      id: '/_protected/(org)/_org-layout/orgs/$orgId/app-access-rules/$ruleId'
      path: '/app-access-rules/$ruleId'
      fullPath: '/orgs/$orgId/app-access-rules/$ruleId'
      preLoaderRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesRuleIdLazyRouteImport
      parentRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdRoute
    }
    '/_protected/(org)/_org-layout/orgs/$orgId/support-tools/$tool': {
      id: '/_protected/(org)/_org-layout/orgs/$orgId/support-tools/$tool'
      path: '/$tool'
      fullPath: '/orgs/$orgId/support-tools/$tool'
      preLoaderRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdSupportToolsToolRouteImport
      parentRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRoute
    }
  }
}

interface ProtectedSupportToolsRouteChildren {
  ProtectedSupportToolsToolRoute: typeof ProtectedSupportToolsToolRoute
}

const ProtectedSupportToolsRouteChildren: ProtectedSupportToolsRouteChildren = {
  ProtectedSupportToolsToolRoute: ProtectedSupportToolsToolRoute,
}

const ProtectedSupportToolsRouteWithChildren =
  ProtectedSupportToolsRoute._addFileChildren(
    ProtectedSupportToolsRouteChildren,
  )

interface ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRouteChildren {
  ProtectedorgOrgLayoutOrgsOrgIdSupportToolsToolRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdSupportToolsToolRoute
}

const ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRouteChildren: ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRouteChildren =
  {
    ProtectedorgOrgLayoutOrgsOrgIdSupportToolsToolRoute:
      ProtectedorgOrgLayoutOrgsOrgIdSupportToolsToolRoute,
  }

const ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRouteWithChildren =
  ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRoute._addFileChildren(
    ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRouteChildren,
  )

interface ProtectedorgOrgLayoutOrgsOrgIdRouteChildren {
  ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRouteWithChildren
  ProtectedorgOrgLayoutOrgsOrgIdAppDataLazyRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdAppDataLazyRoute
  ProtectedorgOrgLayoutOrgsOrgIdDuplicatesLazyRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdDuplicatesLazyRoute
  ProtectedorgOrgLayoutOrgsOrgIdPartialMatchesLazyRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdPartialMatchesLazyRoute
  ProtectedorgOrgLayoutOrgsOrgIdPeopleLazyRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdPeopleLazyRoute
  ProtectedorgOrgLayoutOrgsOrgIdTeamMappingLazyRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdTeamMappingLazyRoute
  ProtectedorgOrgLayoutOrgsOrgIdTeamsLazyRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdTeamsLazyRoute
  ProtectedorgOrgLayoutOrgsOrgIdUserTypesLazyRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdUserTypesLazyRoute
  ProtectedorgOrgLayoutOrgsOrgIdIndexLazyRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdIndexLazyRoute
  ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesRuleIdLazyRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesRuleIdLazyRoute
  ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesCreateLazyRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesCreateLazyRoute
  ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesIndexLazyRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesIndexLazyRoute
}

const ProtectedorgOrgLayoutOrgsOrgIdRouteChildren: ProtectedorgOrgLayoutOrgsOrgIdRouteChildren =
  {
    ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRoute:
      ProtectedorgOrgLayoutOrgsOrgIdSupportToolsRouteWithChildren,
    ProtectedorgOrgLayoutOrgsOrgIdAppDataLazyRoute:
      ProtectedorgOrgLayoutOrgsOrgIdAppDataLazyRoute,
    ProtectedorgOrgLayoutOrgsOrgIdDuplicatesLazyRoute:
      ProtectedorgOrgLayoutOrgsOrgIdDuplicatesLazyRoute,
    ProtectedorgOrgLayoutOrgsOrgIdPartialMatchesLazyRoute:
      ProtectedorgOrgLayoutOrgsOrgIdPartialMatchesLazyRoute,
    ProtectedorgOrgLayoutOrgsOrgIdPeopleLazyRoute:
      ProtectedorgOrgLayoutOrgsOrgIdPeopleLazyRoute,
    ProtectedorgOrgLayoutOrgsOrgIdTeamMappingLazyRoute:
      ProtectedorgOrgLayoutOrgsOrgIdTeamMappingLazyRoute,
    ProtectedorgOrgLayoutOrgsOrgIdTeamsLazyRoute:
      ProtectedorgOrgLayoutOrgsOrgIdTeamsLazyRoute,
    ProtectedorgOrgLayoutOrgsOrgIdUserTypesLazyRoute:
      ProtectedorgOrgLayoutOrgsOrgIdUserTypesLazyRoute,
    ProtectedorgOrgLayoutOrgsOrgIdIndexLazyRoute:
      ProtectedorgOrgLayoutOrgsOrgIdIndexLazyRoute,
    ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesRuleIdLazyRoute:
      ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesRuleIdLazyRoute,
    ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesCreateLazyRoute:
      ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesCreateLazyRoute,
    ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesIndexLazyRoute:
      ProtectedorgOrgLayoutOrgsOrgIdAppAccessRulesIndexLazyRoute,
  }

const ProtectedorgOrgLayoutOrgsOrgIdRouteWithChildren =
  ProtectedorgOrgLayoutOrgsOrgIdRoute._addFileChildren(
    ProtectedorgOrgLayoutOrgsOrgIdRouteChildren,
  )

interface ProtectedorgOrgLayoutRouteChildren {
  ProtectedorgOrgLayoutOrgsOrgIdRoute: typeof ProtectedorgOrgLayoutOrgsOrgIdRouteWithChildren
}

const ProtectedorgOrgLayoutRouteChildren: ProtectedorgOrgLayoutRouteChildren = {
  ProtectedorgOrgLayoutOrgsOrgIdRoute:
    ProtectedorgOrgLayoutOrgsOrgIdRouteWithChildren,
}

const ProtectedorgOrgLayoutRouteWithChildren =
  ProtectedorgOrgLayoutRoute._addFileChildren(
    ProtectedorgOrgLayoutRouteChildren,
  )

interface ProtectedorgRouteChildren {
  ProtectedorgOrgLayoutRoute: typeof ProtectedorgOrgLayoutRouteWithChildren
}

const ProtectedorgRouteChildren: ProtectedorgRouteChildren = {
  ProtectedorgOrgLayoutRoute: ProtectedorgOrgLayoutRouteWithChildren,
}

const ProtectedorgRouteWithChildren = ProtectedorgRoute._addFileChildren(
  ProtectedorgRouteChildren,
)

interface ProtectedpartialMatchesPartialMatchesByAppLazyRouteChildren {
  ProtectedpartialMatchesPartialMatchesByAppAppSlugLazyRoute: typeof ProtectedpartialMatchesPartialMatchesByAppAppSlugLazyRoute
}

const ProtectedpartialMatchesPartialMatchesByAppLazyRouteChildren: ProtectedpartialMatchesPartialMatchesByAppLazyRouteChildren =
  {
    ProtectedpartialMatchesPartialMatchesByAppAppSlugLazyRoute:
      ProtectedpartialMatchesPartialMatchesByAppAppSlugLazyRoute,
  }

const ProtectedpartialMatchesPartialMatchesByAppLazyRouteWithChildren =
  ProtectedpartialMatchesPartialMatchesByAppLazyRoute._addFileChildren(
    ProtectedpartialMatchesPartialMatchesByAppLazyRouteChildren,
  )

interface ProtectedRouteChildren {
  ProtectedSupportToolsRoute: typeof ProtectedSupportToolsRouteWithChildren
  ProtectedOrgsLazyRoute: typeof ProtectedOrgsLazyRoute
  ProtectedorgRoute: typeof ProtectedorgRouteWithChildren
  ProtectedpartialMatchesPartialMatchesRoute: typeof ProtectedpartialMatchesPartialMatchesRoute
  ProtectedpartialMatchesPartialMatchesByAppLazyRoute: typeof ProtectedpartialMatchesPartialMatchesByAppLazyRouteWithChildren
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedSupportToolsRoute: ProtectedSupportToolsRouteWithChildren,
  ProtectedOrgsLazyRoute: ProtectedOrgsLazyRoute,
  ProtectedorgRoute: ProtectedorgRouteWithChildren,
  ProtectedpartialMatchesPartialMatchesRoute:
    ProtectedpartialMatchesPartialMatchesRoute,
  ProtectedpartialMatchesPartialMatchesByAppLazyRoute:
    ProtectedpartialMatchesPartialMatchesByAppLazyRouteWithChildren,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

interface PublicRouteChildren {
  PublicLoginCallbackRoute: typeof PublicLoginCallbackRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginCallbackRoute: PublicLoginCallbackRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
